/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssetsOutputDto { 
    assetId?: number;
    name?: string | null;
    assetType?: string | null;
    assetStatus?: string | null;
    serialNumber?: string | null;
    supplierName?: string | null;
    supplierAddress?: string | null;
    supplierCompany?: string | null;
    entryDate?: string;
    department?: string | null;
    assignedTo?: string | null;
    assignedToUserId?: number | null;
    branchId?: number | null;
    branchName?: string | null;
    assignedDate?: string | null;
}

